export const RECEIVING_ACCOUNT_OPTIONS = [
    { value: 'AGROLEND', label: 'AGROLEND' },
    { value: 'Conta ESCROW', label: 'Conta ESCROW' },
];
